module.exports = __webpack_public_path__ + "media/images/top/for-beginner-mini-44312869485974a6de683727a15796ac.webp";